
import React from "react";
import { useNavigate } from "react-router-dom"; 
import { useWebsitePackages } from "../hooks/useWebsitePackages";
import styles from "./FeaturedPackages1.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const FeaturedPackages1 = ({ companyId, mode, onNavigate, templateId }) => { 
  const navigate = useNavigate();
  
  const { data: packages = [], isLoading } = useWebsitePackages(companyId, "Holiday", mode);

  const handleViewDetails = (pkgId) => {
    if (mode === "builder") {
      onNavigate({ name: "package-details", params: { packageId: pkgId } });
    } else if (mode === "preview") {
      navigate(`/template-preview/${templateId}/package/${pkgId}`);
    } else {
      navigate(`/package/${pkgId}`);
    }
  };

  if (isLoading) return <div className="text-center p-4">Loading packages...</div>;

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>Our Featured Packages</h2>

      <div className={styles.grid}>
        {packages.slice(0, 6).map((pkg, index) => {

          const fallbackImage =
            fallbackImages[index % fallbackImages.length];

          const imageUrl =
            pkg?.imageSrc && pkg.imageSrc.trim() !== ""
              ? pkg.imageSrc
              : fallbackImage;

          return (
            <div key={pkg.packageId} className={styles.card}>
              <img
                src={imageUrl}
                alt={pkg.packageName}
                className={styles.image}
                onError={(e) => {
                  e.target.src = fallbackImage;
                }}
              />

              <div className={styles.content}>
                <h3 className={styles.cardTitle}>{pkg.packageName}</h3>

                <div className={styles.priceRow}>
                  <span className={styles.price}>
                    {pkg.currency} {pkg.price}
                  </span>

                  <button
                    onClick={() => handleViewDetails(pkg.packageId)}
                    className={styles.button}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeaturedPackages1;